// extracted by mini-css-extract-plugin
export default {"item":"GridItem_item__Z2uLk"};